module.exports = __webpack_public_path__ + "img/CautiousNature.5816675c.png";